import * as React from "react";
const SvgAmplitude = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Amplitude_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F7F7F7",
  rx: 6
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Amplitude_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1E61F0",
  d: "M11.551 8.245c.245.735.49 1.673.775 2.735-1.06 0-2.163-.041-3.183-.041h-.53c.611-2.327 1.305-4.123 1.877-4.53.04-.042.081-.042.163-.042s.122.041.204.123c.082.204.327.694.694 1.755M22 12c0 5.51-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2s10 4.49 10 10m-2.571-.245c0-.245-.164-.49-.409-.53h-.163c-1.673-.123-3.428-.164-5.061-.205-.776-2.98-1.796-6-3.102-6-1.225 0-2.367 2-3.347 5.919-.694 0-1.306 0-1.878-.041h-.285c-.327.04-.572.367-.572.694s.245.653.612.694h1.878c-.163.775-.326 1.55-.449 2.285l-.04.327c0 .245.203.449.448.449a.5.5 0 0 0 .408-.204l.898-2.898h4.368c.326 1.265.694 2.571 1.143 3.796.244.653.816 2.204 1.796 2.204 1.469 0 2.04-2.367 2.408-3.919.081-.326.163-.612.204-.857l.04-.081v-.123a.32.32 0 0 0-.163-.163c-.122-.04-.204.04-.245.163l-.04.082c-.123.327-.245.653-.327.939v.04c-.653 1.796-.939 2.613-1.51 2.613-.735 0-1.429-2.98-1.674-4.123-.04-.204-.081-.367-.122-.53h4.775c.082 0 .164-.041.245-.041h.081s.042 0 .042-.04c-.041-.164.04-.287.04-.45"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Amplitude_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Amplitude_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 2h20v20H2z"
}))));
export default SvgAmplitude;
//# sourceMappingURL=Amplitude.js.map